const STORAGE_KEY = 'trading.pnlBadgeMode';

export type PnlMode = 'NET' | 'GROSS';

export function getPnlMode(): PnlMode {
  try {
    const v = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (v === 'GROSS') return 'GROSS';
  } catch {}
  return 'NET';
}

export function setPnlMode(mode: PnlMode) {
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, mode);
      try { window.dispatchEvent(new CustomEvent('tt:pnlModeChanged', { detail: { mode } })); } catch {}
    }
  } catch {}
}

export function onPnlModeChange(cb: (mode: PnlMode) => void) {
  const handler = (ev: any) => cb(ev?.detail?.mode ?? getPnlMode());
  if (typeof window !== 'undefined') window.addEventListener('tt:pnlModeChanged', handler as EventListener);
  return () => { if (typeof window !== 'undefined') window.removeEventListener('tt:pnlModeChanged', handler as EventListener); };
}

export default { getPnlMode, setPnlMode, onPnlModeChange };
